import { z } from 'zod';
import { ArtifactSchema } from '../../entities/artifact/artifact.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Add Artifact Request Schema
 * POST /api/v2/artifacts
 */ export const AddArtifactRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    description: z.string().optional(),
    type: z.string().optional(),
    fileUrl: z.string().optional(),
    size: z.number().optional(),
    mimeType: z.string().optional(),
    createdBy: z.string().optional()
});
/**
 * Add Artifact Response Schema
 * POST /api/v2/artifacts
 */ export const AddArtifactResponseSchema = z.object({
    data: ArtifactSchema
});

//# sourceMappingURL=add-artifact.schema.js.map